import { render, staticRenderFns } from "./TotalDownloads.vue?vue&type=template&id=728b8ecb&"
import script from "./TotalDownloads.vue?vue&type=script&lang=js&"
export * from "./TotalDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports